import { render, staticRenderFns } from "./new.vue?vue&type=template&id=5b81229f&scoped=true"
import script from "./new.vue?vue&type=script&lang=js"
export * from "./new.vue?vue&type=script&lang=js"
import style0 from "./new.vue?vue&type=style&index=0&id=5b81229f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b81229f",
  null
  
)

export default component.exports